export default __webpack_public_path__ + "assets/webgl/scene-10.6876d376.glb";